import { render, staticRenderFns } from "./AddMethodModal.vue?vue&type=template&id=6a57e123"
import script from "./AddMethodModal.vue?vue&type=script&lang=js"
export * from "./AddMethodModal.vue?vue&type=script&lang=js"
import style0 from "./AddMethodModal.vue?vue&type=style&index=0&id=6a57e123&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports